import { atom } from "jotai";

export const openModalHamburger = atom(false);
